<template>
  <div>
    <hr class="yellow-rule" />
    <v-container>
      <v-row class="mb-4">
        <v-col cols="12">
          <h1 class="text-h3">{{ $t("title") }}</h1>
          <Underline />
          <p class="text-body-2 mt-4">{{ $t("updated_at") }} 2026/4/28</p>
        </v-col>
      </v-row>

      <v-row>
        <v-col cols="12">
          <h2 class="text-h6 pa-1">1. Acceptance of Terms</h2>
          <p class="text-body-1 pa-1">
            By accessing or using this website (the "Service"), you agree to be
            bound by these Terms of Service ("Terms"). If you do not agree, you
            must not use the Service.
          </p>
        </v-col>
      </v-row>

      <v-row>
        <v-col cols="12">
          <h2 class="text-h6 pa-1">2. Use of the Service</h2>
          <p class="text-body-1 pa-1">
            You may access and use the Service only for lawful purposes and in
            accordance with these Terms. No right, title, or interest in or to
            the Service, the Content, or any underlying data is transferred to
            you except for the limited right to access the Service as expressly
            permitted by these Terms.
          </p>
        </v-col>
      </v-row>

      <v-row>
        <v-col cols="12">
          <h2 class="text-h6 pa-1">3. Intellectual Property Rights</h2>
          <p class="text-body-1 pa-1">
            The Service and all content made available through it, including but
            not limited to text, data, compilations, design, layout, graphics,
            logos, and software (collectively, "Content"), are owned by or
            licensed to the Company and are protected by applicable laws. All
            rights not expressly granted under these Terms are reserved by the
            Company.
          </p>
        </v-col>
      </v-row>

      <v-row>
        <v-col cols="12">
          <h2 class="text-h6 pa-1">4. User Submissions</h2>
          <p class="text-body-1 pa-1">
            To the extent you submit any data, content, or information through
            the Service ("User Content"), you represent that you have the right
            to do so.
          </p>
          <p class="text-body-1 pa-1">
            You retain ownership of your User Content, but you grant the Company
            a worldwide, non-exclusive, royalty-free license to host, store,
            reproduce, modify, analyze, display, and otherwise use the User
            Content for the purpose of operating, maintaining, improving,
            promoting, and protecting the Service and related offerings.
          </p>
        </v-col>
      </v-row>

      <v-row>
        <v-col cols="12">
          <h2 class="text-h6 pa-1">5. Aggregated and De-Identified Data</h2>
          <p class="text-body-1 pa-1">
            The Company may use User Content and other information collected
            through the Service to generate aggregated, statistical, anonymized,
            or de-identified information that does not identify you personally,
            and may use such information for analytics, research, product
            improvement, benchmarking, and other lawful business purposes.
          </p>
        </v-col>
      </v-row>

      <v-row>
        <v-col cols="12">
          <h2 class="text-h6 pa-1">6. No Implied Rights</h2>
          <p class="text-body-1 pa-1">
            Except as expressly stated in these Terms, nothing in the Service or
            these Terms grants you any right to use the Content, underlying
            data, trademarks, service marks, logos, or other proprietary
            materials of the Company.
          </p>
        </v-col>
      </v-row>

      <v-row>
        <v-col cols="12">
          <h2 class="text-h6 pa-1">7. Monitoring and Enforcement</h2>
          <p class="text-body-1 pa-1">
            The Company reserves the right, but not the obligation, to monitor
            use of the Service, investigate suspected violations of these Terms,
            suspend or restrict access to the Service, and take any other action
            the Company deems appropriate to protect the Service, the Content,
            the underlying data, and its rights and interests.
          </p>
        </v-col>
      </v-row>

      <v-row>
        <v-col cols="12">
          <h2 class="text-h6 pa-1">8. Prohibited Conduct</h2>
          <p class="text-body-1 pa-1">You agree not to:</p>
          <ul class="text-body-1 pa-1 terms-list">
            <li>
              Engage in scraping, crawling, harvesting, or any automated data
              extraction from the Service without prior written consent
            </li>
            <li>
              Copy, reproduce, distribute, publish, or create derivative works
              from the Content for commercial purposes
            </li>
            <li>
              Use the Content to develop, enhance, or operate a competing
              service or product
            </li>
            <li>
              Reverse engineer or attempt to extract underlying datasets or
              database structures
            </li>
            <li>Interfere with or disrupt the Service or its servers</li>
          </ul>
        </v-col>
      </v-row>

      <v-row>
        <v-col cols="12">
          <h2 class="text-h6 pa-1">9. Data Usage and Attribution</h2>
          <p class="text-body-1 pa-1">
            Where use of limited portions of the Content is permitted by law or
            expressly authorized:
          </p>
          <ul class="text-body-1 pa-1 terms-list">
            <li>
              You must provide clear and visible attribution to the Service as
              the source
            </li>
            <li>
              Attribution must include a link to the original page where the
              Content was obtained
            </li>
            <li>
              You must not present the Content in a misleading or altered manner
            </li>
          </ul>
        </v-col>
      </v-row>

      <v-row>
        <v-col cols="12">
          <h2 class="text-h6 pa-1">10. Commercial Use Restriction</h2>
          <p class="text-body-1 pa-1">
            The Content and any underlying data may not be used for:
          </p>
          <ul class="text-body-1 pa-1 terms-list">
            <li>Commercial exploitation</li>
            <li>Marketing or advertising purposes</li>
            <li>Sale, licensing, or redistribution to third parties</li>
          </ul>
          <p class="text-body-1 pa-1">
            without prior written permission from the Company.
          </p>
        </v-col>
      </v-row>

      <v-row>
        <v-col cols="12">
          <h2 class="text-h6 pa-1">11. Third-Party Links and Content</h2>
          <p class="text-body-1 pa-1">
            The Service may contain links to third-party websites, services, or
            resources. The Company is not responsible for the availability,
            accuracy, content, products, or services of third parties, and
            inclusion of a link does not imply endorsement.
          </p>
        </v-col>
      </v-row>

      <v-row>
        <v-col cols="12">
          <h2 class="text-h6 pa-1">12. Disclaimer</h2>
          <p class="text-body-1 pa-1">
            The Service and the Content are provided on an "as is" and "as
            available" basis for informational purposes only. The Company does
            not warrant that the Service will be uninterrupted, error-free,
            secure, complete, current, or accurate.
          </p>
        </v-col>
      </v-row>

      <v-row>
        <v-col cols="12">
          <h2 class="text-h6 pa-1">13. Limitation of Liability</h2>
          <p class="text-body-1 pa-1">
            To the maximum extent permitted by law, the Company shall not be
            liable for any indirect, incidental, special, consequential, or
            punitive damages, or for any loss of profits, revenues, data,
            business, or goodwill, arising out of or related to your use of or
            inability to use the Service.
          </p>
        </v-col>
      </v-row>

      <v-row>
        <v-col cols="12">
          <h2 class="text-h6 pa-1">14. Suspension and Termination</h2>
          <p class="text-body-1 pa-1">
            The Company may suspend, restrict, or terminate your access to the
            Service at any time, with or without notice, if the Company believes
            that you have violated these Terms or that your use of the Service
            creates legal, technical, or business risk.
          </p>
        </v-col>
      </v-row>

      <v-row>
        <v-col cols="12">
          <h2 class="text-h6 pa-1">15. Changes to Terms</h2>
          <p class="text-body-1 pa-1">
            The Company may update these Terms from time to time by posting the
            revised version on the Service. Your continued use of the Service
            after revised Terms become effective constitutes your acceptance of
            the revised Terms to the extent permitted by law.
          </p>
        </v-col>
      </v-row>

      <v-row>
        <v-col cols="12">
          <h2 class="text-h6 pa-1">16. Governing Law</h2>
          <p class="text-body-1 pa-1">
            These Terms shall be governed by and construed in accordance with
            the laws of Japan.
          </p>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<i18n>
{
  "en": {
    "title": "Terms of Service",
    "updated_at": "Updated"
  },
  "ja": {
    "title": "利用規約",
    "updated_at": "更新日"
  }
}
</i18n>

<script>
import Underline from "components/Underline.vue";

export default {
  components: {
    Underline
  },
  metaInfo() {
    return {
      title: this.$t("title"),
      meta: [
        {
          vmid: "description",
          name: "description",
          content:
            "Terms of Service for OpenSalary covering acceptable use, content restrictions, and legal conditions for using the site."
        }
      ]
    };
  }
};
</script>

<style scoped>
.terms-list {
  padding-left: 2rem !important;
}
</style>
